var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 35.5C21 35.5 19 33.1 19 31V22C19 18.4 24.5 16.5 28.5 16.5C32.5 16.5 38 18.4 38 22V31H37V22C37 19.2 32 17.5 28.5 17.5C25 17.5 20 19.2 20 22V31C20 32.6 21.6 34.5 23.5 34.5V35.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.5C25.9 14.5 24 12.6 24 10V8C24 5.4 25.9 3.5 28.5 3.5C31.1 3.5 33 5.4 33 8V10C33 12.6 31.1 14.5 28.5 14.5ZM28.5 4.5C26.4 4.5 25 5.9 25 8V10C25 12.1 26.4 13.5 28.5 13.5C30.6 13.5 32 12.1 32 10V8C32 5.9 30.6 4.5 28.5 4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24H33V33H34V24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44H33V51H34V44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H23V51H24V24Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 44.5H29.5C29.2 44.5 29 44.3 29 44V33C29 32.7 29.2 32.5 29.5 32.5H43.5C43.8 32.5 44 32.7 44 33V44C44 44.3 43.8 44.5 43.5 44.5ZM30 43.5H43V33.5H30V43.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoss);
export default __webpack_public_path__ + "static/media/boss.464726e6c7fcbb38bfd102e35bc24798.svg";
export { ForwardRef as ReactComponent };